import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';
import { Title, TitleTypes } from 'modules/ui';
import * as felaRules from './BlogPostsPage.rules';
import { FormattedMessage } from 'modules/ui/dependencies';

export interface OtherLangTitleLinkProps {
    link: string,
    lang: 'cs' | 'en' | 'de';
}

export const OtherLangTitleLink = ({
    link,
    lang
}: OtherLangTitleLinkProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    return (
        <a href={link} className={styles.link}>
            {/* @ts-expect-error */}
            <Title type={TitleTypes.h2} as={TitleTypes.h2} extend={{ title: rules.otherLangTitle }}>
                <FormattedMessage id={`blog.articles.title.${lang}`} />
            </Title>
        </a>           
    );
};